export const c_toolbar__item_Width = {
  "name": "--pf-v5-c-toolbar__item--Width",
  "value": "auto",
  "var": "var(--pf-v5-c-toolbar__item--Width)"
};
export default c_toolbar__item_Width;